













































import {Component, Vue, Watch} from "vue-property-decorator"
import DatePicker from "@/components/DatePicker.vue"
import LineGraph from "@/components/Graph/LineGraph.vue"
import {vxm} from "@/store"
import {NotificationSummary} from "@/interface"
import moment from "moment"

@Component({components: {DatePicker, LineGraph}})
export default class ReportCTRTransition extends Vue {

  private term: string = "day"
  private start_at: string = ""
  private end_at: string = ""

  private loading: boolean = false

  get notification_summaries(): NotificationSummary[] {
    return vxm.report.notification_summaries || []
  }

  // グラフのX軸の範囲
  get XAxis(): moment.Moment[] {

    let start: moment.Moment = moment()
      , end: moment.Moment   = moment().subtract(1, "year")

    for (let i = 0; i < this.notification_summaries.length; i++) {
      const n        = this.notification_summaries[i]
        , reserve_at = moment(n.reserve_at)
      if (reserve_at.isBefore(start)) start = reserve_at.clone()
      if (reserve_at.isAfter(end)) end = reserve_at.clone()
    }

    start = start.startOf(<any>this.term)
    end = end.endOf(<any>this.term)

    const dates = []
    while (true) {
      dates.push(start.clone())
      start.add(1, <any>this.term)
      if (start.isAfter(end)) break
    }
    return dates
  }

  // ラベル
  get labels() {
    switch (this.term) {
      case "day":
        return this.XAxis.map(d => d.format("M/D"))
      case "week":
        return this.XAxis.map(d => d.format("w"))
      case "month":
        return this.XAxis.map(d => d.format("YYYY/M"))
    }
  }

  get total_datasets() {

    return this.XAxis.map((date: moment.Moment) => {

      // 対象のデータをフィルタリング
      const target_items = this.notification_summaries
        .filter((n: NotificationSummary) => {
          switch (this.term) {
            case "day":
              return moment(n.reserve_at).format("YYYY/MM/DD") === date.format("YYYY/MM/DD")
            case "week":
              return moment(n.reserve_at).week() === date.week()
            case "month":
              return moment(n.reserve_at).format("YYYY/MM") === date.format("YYYY/MM")
          }
        })

      //
      const distribute_count = target_items
        .map(n => n.distribute_count || 0)
        .reduce((prev: number, current: number) => prev + current, 0)

      const open_count = target_items
        .map(n => n.open_count || 0)
        .reduce((prev: number, current: number) => prev + current, 0)

      return Math.round(open_count / distribute_count * 10000) / 100
    })
  }

  created() {
    this.start_at = moment().subtract(3, 'months').format('YYYY-MM-DD')
  }

  async mounted() {
    await this.load()
  }

  async load() {
    this.loading = true
    await vxm.report.fetchNotificationSummaries({
      force   : true,
      start_at: this.start_at ? moment(this.start_at).unix() : undefined,
      end_at  : this.end_at ? moment(this.end_at).unix() : undefined
    })
    this.loading = false
  }

  @Watch("start_at")
  @Watch("end_at")
  async watchStartAt() {

    // 開始より終了が前だったらスワップ
    if (this.start_at && this.end_at) {
      const start = moment(this.start_at)
        , end     = moment(this.end_at)
      if (start.isValid() && end.isValid() && start.isAfter(end)) {
        this.start_at = end.format("YYYY-MM-DD")
        this.end_at = start.format("YYYY-MM-DD")
      }
    }

    await this.load()
  }
}
